import type { FaireProductEntity } from "../../entity_types/product";

export const p_6es4mtanbf: FaireProductEntity = {
  token: "p_6es4mtanbf",
  type: "product",
  name: "Skeleton Hollow-een | Halloween Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/6cb3b532aa14a0a9200da7deb9c4b2aff0912e476d214569c9e86fd5d430a143.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/68662446a254be6028637973e0eecdbffd77f58c789c665e2a63b54409de70ee.jpeg",
    "https://cdn.faire.com/fastly/be651d53596bf08a1ebdb8956178341d6f64c52af77aed4b67c448fc43374c0b.png",
  ],
  priceDollars: 3,
  description:
    "Each E. Frances card begins as an original watercolor painting, and then is printed in brilliant color on luxe, heavyweight paper.",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:37:18.617Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
